// Celular: arrastar o dedo para baixo no topo de uma janela não pode recarregar o jogo.
// Alguns navegadores de celular (vistos nos vídeos de um jogador, 18/10) ignoram o "overscroll-behavior" do CSS e
// fazem o "puxar para atualizar": o jogo recarregava inteiro no meio da rolagem. Aqui o toque só é bloqueado quando
// nada embaixo do dedo consegue rolar naquela direção (aí o gesto iria para a página, que não rola, e viraria refresh);
// rolar listas e janelas, arrastar itens e deslizar para os lados continuam normais.

function canScroll(el: Element | null, dy: number): boolean {
  for (let e = el; e && e !== document.documentElement; e = e.parentElement) {
    if (!(e instanceof HTMLElement)) continue;
    const oy = getComputedStyle(e).overflowY;
    if ((oy !== 'auto' && oy !== 'scroll') || e.scrollHeight <= e.clientHeight + 1) continue;
    if (dy > 0 && e.scrollTop > 0) return true;                                        // dedo descendo: conteúdo sobe
    if (dy < 0 && e.scrollTop + e.clientHeight < e.scrollHeight - 1) return true;       // dedo subindo: conteúdo desce
  }
  return false;
}

/** altura visível de verdade (no Safari do iPhone, 100vh inclui a área por baixo da barra do navegador) */
function trackAppHeight() {
  const set = () => document.documentElement.style.setProperty('--app-h', `${window.visualViewport?.height ?? window.innerHeight}px`);
  set();
  window.addEventListener('resize', set);
  window.visualViewport?.addEventListener('resize', set);
  window.addEventListener('orientationchange', () => setTimeout(set, 300));
}

export function installNoPullRefresh() {
  if (typeof window === 'undefined' || !('ontouchstart' in window)) return;
  trackAppHeight();
  let x0 = 0, y0 = 0, target: Element | null = null, decided = false, block = false;
  window.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 1) { target = null; return; }
    x0 = e.touches[0]!.clientX; y0 = e.touches[0]!.clientY; target = e.target as Element; decided = false; block = false;
  }, { passive: true });
  window.addEventListener('touchmove', (e) => {
    if (!target || e.touches.length !== 1 || !e.cancelable) return;
    const t = e.touches[0]!, dx = t.clientX - x0, dy = t.clientY - y0;
    if (!decided) {
      if (Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
      decided = true;
      // deslizar para os lados (barra de botões, sliders) fica livre; na vertical, só bloqueia se nada puder rolar
      block = Math.abs(dy) > Math.abs(dx) && !canScroll(target, dy);
    }
    if (block) e.preventDefault();
  }, { passive: false });
}
